﻿/**
 * IFrame
 * 
 * @class rlIFrame
 * @memberOf jQuery.fn
 */

(function ($) {
    $.fn.rlIFrame = function () {
        setInterval(function () {
            var iframe = document.getElementsByTagName('iframe')[0];
            if (iframe.contentDocument != null && JSON.stringify(iframe.contentDocument.body) == '{}' && !$("#onetrust-banner-sdk").is(":visible")) {
                $("#sourceLoadErrorMsg").show();
                document.getElementsByTagName('iframe')[0].style.display = 'none';
            }
            else {
                $("#sourceLoadErrorMsg").hide();
                document.getElementsByTagName('iframe')[0].style.display = 'block';
            }
        }, 1000);
    }
}(jQuery));
